<template>
  <Card :name="config.variableFullName">
    <template v-slot:header >
      <h4 class="card-title">
        {{ config.variableFullName }}
      </h4>
    </template>
    <div class="row">
      <i
        class="col col-1 fa "
        :class="[config.icon, getIconColorClass()]"
        style="font-size: 25px;"
      ></i>
      
      <h3 class="col col-4"> {{ value.toFixed(config.decimalPlaces) }} {{ config.unit }}</h3>

      <div class="col col-4">
      <input
        v-model="setValue"
        type="number"
        class="form-control"
        :disabled="!active"
      >
      </div>
      

      <button
      @click="sendValue()"
      :class="[`btn btn-${config.class}`]"
      class="mb-4 col col-2"
      size="sm"
      >{{ config.text || "set" }}</button
    >
    </div>

   
  </Card>
</template>

<script>
import emitter from "@/eventBus"
export default {
  props: ["config"],
  data() {
    return {
      topic: "",
      value: 0,
      setValue: 0,
      active: false
    };
  },
  mounted() {},

  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.status = false;

          emitter.off(this.topic + "/sdata");
          let variable = this.config.variable;  
          if (this.$store.state.selectedDevice.ext_mqtt){
            variable = this.config.variableFullName 
          }
          this.topic =
            this.config.userId +
            "/" +
            this.config.selectedDevice.dId +
            "/" +
            variable;
          emitter.on(this.topic + "/sdata", this.procesReceivedData);
        }, 300);
      }
    }
  },

  beforeDestroy() {
    emitter.off(this.topic + "/sdata");
  },
  
  methods: {
    sendValue() {
      if (!this.active){
        return
      }
      let variable = this.config.variable;  
      if (this.$store.state.selectedDevice.ext_mqtt){
      variable = this.config.variableFullName 
      }
      const toSend = {
        topic: this.topic + "/actdata",
        msg: {
          value: this.setValue
        }
      };

      //console.log(toSend);
      emitter.emit("mqtt-sender", toSend);
      this.setValue = null;
    },

    procesReceivedData(data) {
      if (data == null) return;
      try {
        this.value = data.value;
        this.active = true
      } catch (error) {
        console.log(error);
      }
    },

    getIconColorClass() {
      if (this.config.class == "success") {
        return "text-success";
      }
      if (this.config.class == "primary") {
        return "text-primary";
      }
      if (this.config.class == "warning") {
        return "text-warning";
      }
      if (this.config.class == "danger") {
        return "text-danger";
      }
    }
  }
};
</script>
